import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  /** Desktop primary sidebar collapsed to a narrow icon rail (hms_light layout). */
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      // Default to the collapsed icon rail so the contextual workspace menu is the
      // primary navigation surface — clean, space-efficient (matches hms_light).
      sidebarCollapsed: true,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
    }),
    { name: 'clearring-ui' },
  ),
);
